import { render } from "./ProductManagementView.vue?vue&type=template&id=efcd1630"
import script from "./ProductManagementView.vue?vue&type=script&lang=js"
export * from "./ProductManagementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__